import "./App.css";
import { Survey } from "./pages/Survey";
import "bootstrap/dist/css/bootstrap.min.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ThankYouPage } from "pages/ThankYouPage";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route exact path="/" element={<Survey />} />
          <Route exact path="/:surveyCode/:uuid/" element={<Survey />} />
          <Route path="/:surveyCode/:uuid/:answer" element={<Survey />} />
          <Route path="/thankyou" element={<ThankYouPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
